import React from 'react';
import {Route} from 'react-router';
import ExpiredPage from 'components/ExpiredPage';
import {LoggedOutWindow} from 'components/LoggedOutWindow';
import NotFound from '@components/not-found';

/**
 * Accessible outside the AppComponent
 */
export const unauthorizedRoutes = (
  <>
    <Route path="/expired(/:type)" component={ExpiredPage} />
    <Route path="/loggedOutWindow" component={LoggedOutWindow} />

    {/* 404*/}
    <Route path="*" component={NotFound} />
  </>
);
